const Mappings = ({ mappings, title, isOneLine = false }) => {
  return (
    mappings?.length > 0 && (
      <div className="flex flex-row">
        <div className={`font-bold text-sm`}>{title} : </div>
        <div className="">
          {isOneLine
            ? mappings.map((mapping, index) => (
                <span
                  key={`${mapping?.name}-${index}`}
                  className={`${index % 2 !== 0 && 'pl-2 pr-2'} underline`}
                >
                  {mapping?.name}
                </span>
              ))
            : mappings.map((mapping, index) => (
                <div key={index} className="mb-1">
                  <div className="underline">
                    {mapping?.name ? mapping?.name : mapping?.id}
                  </div>
                  <div className="text-sm">{mapping?.description}</div>
                </div>
              ))}
        </div>
      </div>
    )
  )
}

export default Mappings
